import { IProductDefinitionList, NodeObjectRepository } from '@/models/assembly';

export const ApsisMasa = {
  'apsis-masa': {
    steps: [
      {

        order: 1,
        desc: '1',
        apply: (repository: NodeObjectRepository): void => {

          const ayak1 = repository.get('apsis_masa_ayak_polisali_1_yyy');


          const ayak2 = repository.get('apsis_masa_ayak_polisali_2_yyy');

          const sbp1 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_1_yyy').changePosition((x, y, z) => {
            return {
              y: y - 50,
            };
          }).show();

          const sbp2 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_2_yyy').changePosition((x, y, z) => {
            return {
              y: y - 50,
            };
          }).show();


          ayak1.show();
          ayak2.show();

          sbp1.resetPosition(1.5);

          sbp2.resetPosition(1.5);
          repository.track(ayak1, ayak2,sbp1,sbp2);
        },
      },
      {
        order: 2,
        desc: '2',
        apply: (repository: NodeObjectRepository): void => {

          const ayak1 = repository.get('apsis_masa_ayak_polisali_1_yyy').show();


          const ayak2 = repository.get('apsis_masa_ayak_polisali_2_yyy').show();

          const sbp1 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_1_yyy').show();

          const sbp2 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_2_yyy').show();

          const cnk1 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_1_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z - 20,
              };
            });

          const cnk2 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_2_yyy')
            .changePosition((x, y, z) => {
              return {
                z: z + 20,
              };
            });


          cnk1.show();
          cnk1.resetPosition(1.5);
          cnk2.show();
          cnk2.resetPosition(1.5);
          repository.track(ayak1, ayak2,sbp1,sbp2,cnk1,cnk2);
        },
      },
      {

        order: 3,
        desc: '3',
        apply: (repository: NodeObjectRepository): void => {


          const ayak1 = repository.get('apsis_masa_ayak_polisali_1_yyy')
          .changePosition((x, y, z) => {
            return {
              z: z + 20,
            };
          }).show();

          const ayak2 = repository.get('apsis_masa_ayak_polisali_2_yyy')
          .changePosition((x, y, z) => {
            return {
              z: z - 20,
            };
          }).show();

          const sbp1 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_1_yyy').hide();

          const sbp2 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_2_yyy').hide();


          const cnk1 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_1_yyy').hide();


          const cnk2 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_2_yyy').hide();

          const atki = repository.get('apsis_masa_ara_atki_800_arc29_yyy').show();
          ayak1.resetPosition(1.5);
          ayak2.resetPosition(1.5);
          sbp1.show();
          sbp2.show();
          cnk2.show();
          cnk1.show();
          repository.track(ayak1,ayak2,sbp1,sbp2,cnk1,cnk2,atki);
        },
      },
      {
        order: 4,
        desc: '4',
        apply: (repository: NodeObjectRepository): void => {

          const ayak1 = repository.get('apsis_masa_ayak_polisali_1_yyy').hide();


          const ayak2 = repository.get('apsis_masa_ayak_polisali_2_yyy').hide();

          const sbp1 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_1_yyy').hide();

          const sbp2 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_2_yyy').hide();


          const cnk1 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_1_yyy').hide();


          const cnk2 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_2_yyy').hide();

          const atki = repository.get('apsis_masa_ara_atki_800_arc29_yyy').hide();


          const tb = repository.get('apsis_masa_travers_yyy');


          const adap = repository.get('apsis_masa_travers_alm_bag_adap_ku_yyy')
          .changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });

          const civ = repository.get('apsis_masa_m8_35_hb_imbus_civata_1_yyy')
          .changePosition((x, y, z) => {
            return {
              x: x + 50,
            };
          });
          const civ2 = repository.get('apsis_masa_m8_35_hb_imbus_civata_2_yyy')
          .changePosition((x, y, z) => {
            return {
              x: x - 50,
            };
          });

          tb.show();
          tb.resetPosition(1.5);
          adap.show();
          adap.resetPosition(1.5);
          civ.show();
          civ.resetPosition(1.5);
          civ2.show();
          civ2.resetPosition(1.5);
          repository.track(ayak1,ayak2,sbp1,sbp2,cnk1,cnk2,atki,tb,adap,civ,civ2);
        },
      },
      {

        order: 5,
        desc: '5',
        apply: (repository: NodeObjectRepository): void => {

          const ayak1 = repository.get('apsis_masa_ayak_polisali_1_yyy').show();


          const ayak2 = repository.get('apsis_masa_ayak_polisali_2_yyy').show();

          const sbp1 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_1_yyy').show();

          const sbp2 = repository.get('apsis_masa_genesis_ayk_sbp_png_m8_gri_2_yyy').show();


          const cnk1 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_1_yyy').show();


          const cnk2 = repository.get('apsis_masa_m6_dikdortgen_somn_cnk_2_yyy').show();

          const atki = repository.get('apsis_masa_ara_atki_800_arc29_yyy').show();

          const tb = repository.get('apsis_masa_travers_yyy');
          tb.show();
          const cvt = repository.get('apsis_masa_m6_45_yhb_civata_cinko_1_yyy').changePosition((x, y, z) => {
            return {

              x: x - 20,
            };
          });
          const cvt1 = repository.get('apsis_masa_m6_45_yhb_civata_cinko_2_yyy').changePosition((x, y, z) => {
            return {
              x: x + 20,
            };
          });
          cvt.show();
          cvt.resetPosition(1.5);
          cvt1.show();
          cvt1.resetPosition(1.5);
          repository.track(ayak1,ayak2,sbp1,sbp2,cnk1,cnk2,atki,tb,cvt,cvt1);
        },
      },
      {

        order: 6,
        desc: '6',
        apply: (repository: NodeObjectRepository): void => {

          const masa = repository.get('apsis_masa_tabla18mm_yyy').changePosition((x, y, z) => {
            return {
              y: y + 20,
            };
          });


          const baglan = repository.get('apsis_masa_alm_tabl_baglan_par_ku_yyy').show();

          const civata = repository.get('apsis_masa_m6_12_ysb_civata_cinko_1_yyy').changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });



          masa.show();
          masa.resetPosition(1.5);
          civata.show();
          civata.resetPosition(1.5);
          repository.track(masa,baglan,civata);
        },
      },
      {
        order: 7,
        desc: '7',
        apply: (repository: NodeObjectRepository): void => {


          const panel = repository.get('apsis_masa_alm_on_panel_tut_kumlu_yyy').changePosition((x, y, z) => {
            return {
              y: y - 10,
            };
          });

          const civata = repository.get('apsis_masa_m6_15_ysb_civata_siyah_yyy').changePosition((x, y, z) => {
            return {
              y: y - 20,
            };
          });





          panel.show();
          panel.resetPosition(1.5);

          civata.show();
          civata.resetPosition(1.5);
          repository.track(panel,civata);
        },
      },
      {
        desc: '8',
        order: 8,
        apply: (repository: NodeObjectRepository): void => {




          const perde = repository.get('apsis_masa_on_perde_18mm_yyy').changePosition((x, y, z) => {
            return {
              z: z - 20,
            };
          });

          const civata = repository.get('apsis_masa_m6_15_ysb_civata_siyah_2_yyy').changePosition((x, y, z) => {
            return {
              z: z + 20,
            };
          });


          perde.show();
          perde.resetPosition(1.5);

          civata.show();
          civata.resetPosition(1.5);
          repository.track(perde,civata);
        },
      },
    ],
  },
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/models/assembly/defs/apsis-masa.ts